import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const payStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const paySuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const payError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const payDafSuccess = (state, { data }) => ({
  ...state,
  dafData: data,
  isLoading: false,
});

export const payDafError = (state, { error }) => ({
  ...state,
  dafError: error,
  isLoading: false,
});

export const confirmStripePaymentIntentSuccess = (state, { data }) => ({
  ...state,
  stripePaymentIntent: data,
});

export const transactionsSuccess = (state, { data }) => ({
  ...state,
  completedTransactions: data,
});

export const payCleanUp = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.PAY_START]: payStart,
  [Types.PAY_SUCCESS]: paySuccess,
  [Types.PAY_ERROR]: payError,
  [Types.PAY_CLEAN_UP]: payCleanUp,
  [Types.PAY_DAF_SUCCESS]: payDafSuccess,
  [Types.PAY_DAF_ERROR]: payDafError,
  [Types.CONFIRM_STRIPE_PAYMENT_INTENT_SUCCESS]: confirmStripePaymentIntentSuccess,
  [Types.TRANSACTIONS_SUCCESS]: transactionsSuccess,
};

export default createReducer(INITIAL_STATE, HANDLERS);
